import { Component, OnInit } from '@angular/core';
import { ChangePasswordComponent } from 'src/app/pages/operators/change-password/change-password.component';
import { MatDialog } from '@angular/material/dialog';
import { RolesService } from 'src/app/services/roles.service';
import { MainService } from 'src/app/services/main.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {


  constructor(public dialog: MatDialog,
    private mainServ: MainService,
    private rolsService: RolesService){}
  ngOnInit(){}

  change_password() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
     
      if(result){
        this.rolsService.changePw(result).subscribe((res:any) => {
          console.log(res)
          this.mainServ.SuccessToast('Password Successfully changed.')
        },(err:any) => {
          this.mainServ.erorrToast(err.error.message)
        })
      }
    });
  }
  
  logout(){
    localStorage.clear()
    location.reload()
  }
}
